import spartaSqueezeboxUtility from '@sparta.global.utilities/sparta-squeezebox-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<section class=\"row\">\n  <div class=\"column small-12 resources-nl-module--header-wrapper\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"header") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":4},"end":{"line":7,"column":11}}})) != null ? stack1 : "")
    + "  </div>\n\n  <section class=\"squeezebox-wrapper\" id=\"resourcesNlAccordion\" data-accordion-type=\"accordion\"\n    data-one-at-a-time=\"true\">\n\n    <div class=\"squeezebox-panels\" data-one-at-a-time=\"true\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"accordion") : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":6},"end":{"line":46,"column":15}}})) != null ? stack1 : "")
    + "    </div>\n  </section>\n</section>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <h3 class=\"resources-nl-module--header\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"header") || (depth0 != null ? lookupProperty(depth0,"header") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"header","hash":{},"data":data,"loc":{"start":{"line":5,"column":44},"end":{"line":5,"column":56}}}) : helper)))
    + "</h3>\n    <p class=\"resources-nl-module--subheader\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"subHeader") || (depth0 != null ? lookupProperty(depth0,"subHeader") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"subHeader","hash":{},"data":data,"loc":{"start":{"line":6,"column":46},"end":{"line":6,"column":61}}}) : helper)))
    + "</p>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"squeezebox-panel "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"active") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":35},"end":{"line":15,"column":63}}})) != null ? stack1 : "")
    + "\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":15,"column":69},"end":{"line":15,"column":75}}}) : helper)))
    + "Panel\">\n        <button class=\"panel-header spa-oline spa-btn spa-btn--link gray\" data-panel=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":16,"column":86},"end":{"line":16,"column":92}}}) : helper)))
    + "Panel\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":16,"column":103},"end":{"line":16,"column":109}}}) : helper)))
    + "Accordion\"\n          role=\"application\">\n          <span class=\"spa-squeezebox-arrow spa-icon\"></span>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"header") || (depth0 != null ? lookupProperty(depth0,"header") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"header","hash":{},"data":data,"loc":{"start":{"line":18,"column":61},"end":{"line":18,"column":75}}}) : helper))) != null ? stack1 : "")
    + "\n          <span class=\"ada-hidden\"></span>\n        </button>\n        <div class=\"panel-content light\" aria-labelledby=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":21,"column":58},"end":{"line":21,"column":64}}}) : helper)))
    + "Accordion\">\n          <div class=\"content\">\n            <div class=\"row\">\n              <div class=\"column small-12\">\n                <section class=\"resources-nl-module--content-wrapper clearfix\">\n                  <div class=\"resources-nl-module--image-wrapper "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"class") || (depth0 != null ? lookupProperty(depth0,"class") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"class","hash":{},"data":data,"loc":{"start":{"line":26,"column":65},"end":{"line":26,"column":76}}}) : helper)))
    + "\">\n                    <img class=\"resources-nl-module--image\" src=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"image") || (depth0 != null ? lookupProperty(depth0,"image") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"image","hash":{},"data":data,"loc":{"start":{"line":27,"column":65},"end":{"line":27,"column":76}}}) : helper)))
    + "\" alt=\""
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"header") || (depth0 != null ? lookupProperty(depth0,"header") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"header","hash":{},"data":data,"loc":{"start":{"line":27,"column":83},"end":{"line":27,"column":97}}}) : helper))) != null ? stack1 : "")
    + "\" />\n                  </div>\n                  <div class=\"resources-nl-module--content-details\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"content") : depth0),{"name":"each","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":30,"column":20},"end":{"line":38,"column":29}}})) != null ? stack1 : "")
    + "                  </div>\n                </section>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n";
},"5":function(container,depth0,helpers,partials,data) {
    return " active";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"para") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":20},"end":{"line":33,"column":27}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"link") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":34,"column":20},"end":{"line":37,"column":27}}})) != null ? stack1 : "");
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <p data-font=\"cnx-regular\" class=\"resources-nl-module--content\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":32,"column":84},"end":{"line":32,"column":99}}}) : helper))) != null ? stack1 : "")
    + "</p>\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <p data-font=\"cnx-regular\" class=\"resources-nl-module--content resources-nl-module--link\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":35,"column":110},"end":{"line":36,"column":33}}}) : helper))) != null ? stack1 : "")
    + "</p>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"local") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":50,"column":9}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/resources-nl-module",
  "version": "1.0.2",
  "id": "resourcesNlModule",
  "containerID": "homeLoansResourcesNlModule",
  "moduleName": "home-loans-resources-nl-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "resources-nl-module",
  "data": {
    "init": "resourcesNlModuleJS",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-squeezebox-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0"
  },
  "stores": []
};

/**
 * @class resourcesNlModuleJS
 * @extends {Module}
 */
class resourcesNlModuleJS extends Module {
  /**
   * Creates an instance of resourcesNlModuleJS.
   * @param {Object} options Module options
   * @param {Object} context Module context
   * @memberof resourcesNlModuleJS
   */
  constructor(options, context) {
    // extend
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * Initialize Accordion
   * @returns {void}
   */
  initializeResourcesAccordion() {
    spartaSqueezeboxUtility.init();
  }

  /**
   * Initialize resources-nl-module
   * @returns {void}
   */
  init() {
    // initialize accordion
    this.initializeResourcesAccordion();
  }
}
registerModuleClass({
  moduleClass: resourcesNlModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { resourcesNlModuleJS as default, moduleConfig };
